/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore, {
  countModule
} from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const activeFacilityCount = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;

  try {
    const res = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.activeFacilityCount}/${companyId}`,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    useCompanyStore
      .getState()
      .setCurrentCount(countModule.facility, res.data?.count);

    return res.data;
  } catch (err) {
    useCompanyStore.getState().setCurrentCount(countModule.facility, 0);
  }
};

export default activeFacilityCount;
